import { useState, useEffect } from 'react';
import { ContentKeywordGq } from '../../../../../graphql/projects/models/ContentKeywordGq';
import { projectsApiService } from '../../../../../graphql/projects/projectsApiService';
import { useDebounceValue } from '../../../../../logic/otherUtilities/useDebounceValue';
import { useContentKeywordSearchTableState } from '../../Tables/ContentKeywordAddTable/logic/useContentKeywordSearchTableState';

interface KeywordSearchInput {
  contentTaskId: number;
  projectId: number;
  setLocalAddKeywords: React.Dispatch<React.SetStateAction<ContentKeywordGq[]>>;
}

export function useAddKeywordSearch({
  contentTaskId,
  projectId,
  setLocalAddKeywords,
}: KeywordSearchInput) {
  const [showAddTable, setShowAddTable] = useState(false);
  const addTableState = useContentKeywordSearchTableState({
    invertSelection: false, //Not used
    contentKeywordIds: [],
    emptyIsAll: false,
  });

  // Search logic
  const [addSearchTerm, setAddSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounceValue(addSearchTerm);
  const [{ rowsPerPage, page }, setPaging] = useState({
    page: 0,
    rowsPerPage: 5,
  });

  const keywordQuery = projectsApiService.queries.useGetContentTaskKeywords({
    searchTerm: debouncedSearchTerm,
    projectId: projectId,
    rowsPerPage: debouncedSearchTerm.length ? rowsPerPage : 0,
    page,
    volumeSortDirection: 'desc',
    excludeTaskId: contentTaskId,
  });

  useEffect(() => {
    setPaging((prev) => ({ ...prev, page: 0 }));
  }, [addSearchTerm]);

  useEffect(
    () => setLocalAddKeywords(keywordQuery.contentTaskKeywords),
    [keywordQuery.contentTaskKeywords]
  );

  return {
    keywordQuery,
    addSearchTerm,
    debouncedSearchTerm,
    setAddSearchTerm,
    setPaging,
    showAddTable,
    setShowAddTable,
    addTableState,
  };
}
